<div class="container my-5">
  <div class="row">
    <div class="col-md-8">
      <span class="text-primary h5 fw-bold"></span><span class="h6"></span>
      <h3 class="fw-bolder mb-3">Inloggen</h3>
      <p>
        Dit gedeelte van de website is alleen toegankelijk voor medewerkers van Buurtzorg. Inloggen kan heel eenvoudig met je Buurtzorg Google
        account.
      </p>
      <br />

      @if (!loading) {
        <app-login-form (firebaseUser)="userLoggedIn($event)"></app-login-form>
      } @else {
        <app-loading></app-loading>
      }
    </div>
  </div>
</div>
